import { useCallback } from "react";

import { serverEndSession } from "api/api-server-actions";
import { useVirtualClassActions } from "components/av/virtual-class-utils";
import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { Menu, MenuDivider, MenuItem } from "mds/components/Menu";
import { CopySendArrowIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import {
  selectActiveClassSessionId,
  selectIsClassSessionInPerson,
  selectIsPracticeClassSession,
} from "store/selectors";
import { useClassActions } from "utils/class-utils";

const EndClassMenu = () => {
  const classSessionId = useAppSelector(selectActiveClassSessionId);
  const isClassSessionInPerson = useAppSelector(selectIsClassSessionInPerson);
  const isPracticeClassSession = useAppSelector(selectIsPracticeClassSession);
  const { leaveClass } = useClassActions();
  const { stopVirtualClass } = useVirtualClassActions();

  const endClassSession = useCallback(() => {
    if (!classSessionId) return;

    if (isClassSessionInPerson) {
      serverEndSession(classSessionId);
    } else {
      stopVirtualClass();
    }
  }, [classSessionId, isClassSessionInPerson, stopVirtualClass]);

  const MenuButton = (
    <Button
      className="bg-red-shade-20 text-white group-data-[dark]/themable:bg-red-shade-20 group-data-[dark]/themable:text-white"
      kind="squareLegacy"
      size="l"
      title={t("av.end_class_options")}
      isSquare
    >
      <CopySendArrowIcon />
    </Button>
  );

  return (
    <Menu className="dark-menu" direction="top" menuButton={MenuButton}>
      {!isPracticeClassSession && (
        <>
          <MenuItem eventName="Leave class" onClick={leaveClass}>
            {isPracticeClassSession
              ? t("section.start_session_menu.leave_practice")
              : t("av.leave_virtual_class")}
          </MenuItem>

          <MenuDivider />
        </>
      )}

      <MenuItem eventName="End class for all" onClick={endClassSession}>
        {isPracticeClassSession ? t("section.start_session_menu.end_practice") : t("av.end_class")}
      </MenuItem>
    </Menu>
  );
};

// Using default export to allow lazy-loading
// eslint-disable-next-line import/no-default-export
export default EndClassMenu;
